import { toJS } from "mobx";
import { toCamelCase } from "./objectHelper";

//Available sourceelements that can with interaction resolve conditions
const navigate = (module, orders, activePersonNo) => {
  if (orders) {
    let order = toJS(orders)[activePersonNo];
    if (module !== undefined && order !== undefined) {
      switch (module.contentModule.type) {
        case "FIELD":
          return fieldHandler(module, order);
        case "QUESTION":
          return questionHandler(module, order);
        case "EVENT":
          return eventHandler(module, order);
        case "EVENT_GROUP":
          return eventGroupHandler(module, order);
        default:
          return null;
      }
    }
  }
  return null;
};

const fieldHandler = (module, order) => {
  let type = order[toCamelCase(module.contentModule.settings.type)];
  if (type) {
    let val = type[toCamelCase(module.contentModule.settings.fieldType)];
    if (val) {
      return val;
    }
  }
  return null;
};

const questionHandler = (module, order) => {
  if (module.contentModule.settings.type === "text") {
    if (order.answer) {
      let answer = order.answer.find((a) => a.questionId == module.contentModule.settings.questionId);
      if (answer && answer.answerRow && answer.answerRow.length > 0) {
        let row = answer.answerRow.find((ar) => ar.questionOptionId == 0);
        if (row && !row.deleted) {
          return row.text;
        }
      }
    }
  }
  if (module.contentModule.settings.type === "option") {
    let checkedOptions = order?.answer?.find((a) => a.questionId == module.contentModule.settings.questionId)?.answerRow;
    if (!checkedOptions) return null;

    return checkedOptions.map((co) => {
      return co.questionOptionId;
    });
  }
  return null;
};

const eventHandler = (module, order) => {
  if (order.orderRow) {
    console.log(module, order);
    let row = order.orderRow.find((or) => or.eventId == module.contentModule.settings.eventId);
    if (row && !row.deleted) {
      return true;
    }
  }
  return false;
};

const eventGroupHandler = (module, order) => {
  const moduleEventIds = module?.contentModule?.settings?.eventIds?.map((e) => e.eventId) ?? [];
  if (order.orderRow) {
    return order.orderRow
      .filter((or) => !or.deleted && or.eventId !== order.eventId && moduleEventIds.includes(or.eventId))
      .map((or) => {
        return or.eventId;
      });
  }
  return [];
};

export const conditionNavigator = {
  navigate,
};
